module.exports = __webpack_public_path__ + "img/实训中心设备.0107dd28.png";